import { Injectable } from '@angular/core';
import { PaymentSummaryDataDto } from '@data/data/models/payment-summary.dto';
import { DESKTOP_DISABLED_BANKS, paymentInstructions } from '@data/domain/enums/payment.constant';
import { PaymentMethod } from '@data/domain/payment-method.entity';
import { PaymentMethodItemViewModel, PaymentViewModel } from '@presentation/view-models/payment-method.view-model';
import { Formatter } from '@shared/utils.formatter';
import { ITEM } from '@utils/constants';


@Injectable()
export class CompatiblePaymentMethodMapper {
    mapFrom(paymentMethod: PaymentMethod[], detail: PaymentSummaryDataDto): PaymentViewModel {
        return {
            paymentSummary: [
                {
                    key: detail.name,
                    value: Formatter.toLocaleCurrency(detail.amount)
                },
                {
                    key: `No tujuan ${detail.msisdn}`,
                    value: ''
                },
                {
                    key: `${detail.qty} x ${Formatter.toLocaleCurrency(detail.amount)}`,
                    value: ''
                },
                {
                    key: 'Sub Total',
                    value: Formatter.toLocaleCurrency(detail.paymentSummary.subtotal)
                },
                {
                    key: 'Diskon',
                    value: '-'
                },
                {
                    key: 'Admin Fee',
                    value: detail.paymentSummary.fee > ITEM.DEFAULT_VALUE ? Formatter.toLocaleCurrency(detail.paymentSummary.fee) : '-'
                },
                {
                    key: 'Pajak',
                    value: '-'
                },
                {
                    key: 'Total Tagihan',
                    value: detail.paymentSummary.totalAmount > ITEM.DEFAULT_VALUE ? Formatter.toLocaleCurrency(detail.paymentSummary.totalAmount) : '-'
                },
                {
                    key: 'Cashback',
                    value: '-'
                }
            ],
            paymentMethods: paymentMethod.map((payment) => {
                return {
                    title: payment.title,
                    type: payment.type,
                    list: payment.list.map(item => ({
                        title: item.title,
                        bankName: this.capitalizeFirst(item.bankName),
                        icon: item.icon,
                        paymentMethod: item.paymentMethod,
                        howToPay: item.howToPay,
                        sourceType: item.sourceType ?? '',
                        term: item.term,
                        isMobileOnly: DESKTOP_DISABLED_BANKS.includes(item.bankName.toLowerCase().trim()),
                        paymentInstructions: paymentInstructions[item.bankName.toLowerCase().trim()] || '',
                        msisdn: '',
                        paymentType: item.paymentType
                    }) as PaymentMethodItemViewModel)
                };
            })
        };
    }

    private capitalizeFirst(str: string) {        
        // If first character is already uppercase, return as is
        if (str.charAt(ITEM.EMPTY_LENGTH) === str.charAt(ITEM.EMPTY_LENGTH).toUpperCase()) {
            return str;
        }
        
        // Only capitalize if first character is lowercase
        return str.charAt(ITEM.EMPTY_LENGTH).toUpperCase() + str.slice(ITEM.SINGLE_EMISSION);
    }
}
